import getDependentTechnologies from './getDependendTechnologies'

const utils = {
  getDependentTechnologies,
}

export default utils
